// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class MenuBarController {
   $scope: any
   chat: any
   constructor($scope: any, chat: any) {
      this.$scope = $scope
      this.chat = chat
      this.$scope.chat = this.chat.scope.chat
   }
}

MenuBarController.$inject = ['$scope', 'chatService']

angular.module('summonApp.controllers')
   .controller('MenuBarCtrl', MenuBarController)
